import { IGerarBoletoAilos, IGerarPDFAilos, IGerarRemessaAilos, IGerarRetornoAilos } from "@/banks/ailos/types";
import { IGerarBoletoBradesco, IGerarPDFBradesco, IGerarRemessaBradesco, IGerarRetornoBradesco } from "@/banks/bradesco/types";
import { IGerarBoletoSicredi, IGerarPDFSicredi, IGerarRemessaSicredi, IGerarRetornoSicredi } from "@/banks/sicredi/types";
import { IGerarBoletoSicoob, IGerarPDFSicoob, IGerarRemessaSicoob, IGerarRetornoSicoob } from "@/banks/sicoob/types";
import { IGerarBoletoBancoBrasil, IGerarPDFBancoBrasil, IGerarRemessaBancoBrasil, IGerarRetornoBancoBrasil } from "@/banks/banco-brasil/types";
import { IGerarPDFItau } from "@/banks/itau/types";

export type IGerarBoleto =
  IGerarBoletoAilos |
  IGerarBoletoBradesco |
  IGerarBoletoSicredi |
  IGerarBoletoSicoob |
  IGerarBoletoBancoBrasil;

export type IGerarPDF =
  IGerarPDFAilos |
  IGerarPDFBradesco |
  IGerarPDFSicredi |
  IGerarPDFSicoob |
  IGerarPDFBancoBrasil |
  IGerarPDFItau;

export type IGerarRemessa =
  IGerarRemessaAilos |
  IGerarRemessaBradesco |
  IGerarRemessaSicredi |
  IGerarRemessaSicoob |
  IGerarRemessaBancoBrasil;

export type IGerarRetorno =
  IGerarRetornoAilos |
  IGerarRetornoBradesco |
  IGerarRetornoSicredi |
  IGerarRetornoSicoob |
  IGerarRetornoBancoBrasil;

export enum Banco {
  AILOS = '085',
  BRADESCO = '005',
  SICREDI = '748',
  SICOOB = '756',
  BANCO_BRASIL = '001',
  ITAU = '341',
}
